import { h, Component } from 'preact';

function niceCeil(value) {
    if (!value || value <= 0) return 1;
    const padded = value * 1.1;
    const magnitude = 10 ** Math.floor(Math.log10(padded));
    return Math.ceil(padded / magnitude) * magnitude;
}

class BarChartHorizontal extends Component {
    render() {
        const {
            data = [],
            barHeight = 22,
            barGap = 10,
            valueFormat = v => v,
            paddingLeft = 80,
            paddingRight = 50,
            paddingTop = 8,
            paddingBottom = 8,
        } = this.props;

        const width = 480;
        const height = paddingTop + paddingBottom + data.length * barHeight + (data.length - 1) * barGap;
        const innerWidth = width - paddingLeft - paddingRight;
        const max = data.reduce((m, d) => Math.max(m, d.value || 0), 0);
        const xMax = niceCeil(max);

        return (
            <svg
                viewBox={`0 0 ${width} ${height}`}
                preserveAspectRatio='xMidYMid meet'
                style={`width: 100%; height: ${height}px; max-height: ${height}px;`}
                role='img'
            >
                {data.map((d, i) => {
                    const value = d.value || 0;
                    const w = xMax > 0 ? (value / xMax) * innerWidth : 0;
                    const y = paddingTop + i * (barHeight + barGap);
                    return (
                        <g key={`hbar-${i}`}>
                            <text
                                x={paddingLeft - 6}
                                y={y + barHeight / 2 + 4}
                                text-anchor='end'
                                font-size='12'
                                fill='currentColor'
                            >
                                {d.label}
                            </text>
                            <rect
                                x={paddingLeft}
                                y={y}
                                width={w}
                                height={barHeight}
                                fill={d.color || 'var(--bs-primary)'}
                                rx='3'
                            />
                            <text
                                x={paddingLeft + w + 6}
                                y={y + barHeight / 2 + 4}
                                text-anchor='start'
                                font-size='12'
                                fill='currentColor'
                            >
                                {valueFormat(value)}
                            </text>
                        </g>
                    );
                })}
            </svg>
        );
    }
}

export default BarChartHorizontal;
